import { categories } from "@/mocks/seo-data";

const remainingCategories = [
  { ...categories[7], image: "https://readdy.ai/api/search-image?query=Minimalist%20soft%20fabric%20texture%20on%20warm%20cream%20surface%2C%20clean%20product%20photography%2C%20soft%20natural%20lighting%2C%20simple%20elegant%20composition%2C%20neutral%20warm%20aesthetic&width=200&height=140&seq=more-cat-underwear-v2&orientation=landscape" },
  { ...categories[8], image: "https://readdy.ai/api/search-image?query=Stylish%20sports%20jersey%20fabric%20on%20warm%20beige%20backdrop%2C%20minimalist%20product%20photography%2C%20soft%20natural%20lighting%2C%20clean%20composition%2C%20editorial%20aesthetic&width=200&height=140&seq=more-cat-jersey-v2&orientation=landscape" },
  { ...categories[9], image: "https://readdy.ai/api/search-image?query=Elegant%20fashion%20accessories%20on%20warm%20cream%20background%2C%20minimalist%20product%20photography%2C%20soft%20natural%20daylight%2C%20clean%20editorial%20style%2C%20neutral%20tones&width=200&height=140&seq=more-cat-accessories-v2&orientation=landscape" },
  { ...categories[10], image: "https://readdy.ai/api/search-image?query=Modern%20stylish%20bag%20on%20warm%20beige%20surface%2C%20minimalist%20product%20photography%2C%20soft%20natural%20lighting%2C%20clean%20composition%2C%20editorial%20aesthetic&width=200&height=140&seq=more-cat-bags-v2&orientation=landscape" },
  { ...categories[11], image: "https://readdy.ai/api/search-image?query=Elegant%20leather%20belt%20on%20warm%20cream%20background%2C%20minimalist%20product%20photography%2C%20soft%20natural%20lighting%2C%20clean%20editorial%20style&width=200&height=140&seq=more-cat-belts-v2&orientation=landscape" },
  { ...categories[12], image: "https://readdy.ai/api/search-image?query=Stylish%20fragrance%20bottle%20on%20warm%20beige%20surface%2C%20minimalist%20product%20photography%2C%20soft%20natural%20lighting%2C%20clean%20composition%2C%20editorial%20aesthetic&width=200&height=140&seq=more-cat-perfumes-v2&orientation=landscape" },
  { ...categories[13], image: "https://readdy.ai/api/search-image?query=Various%20stylish%20product%20items%20on%20warm%20cream%20surface%2C%20minimalist%20product%20photography%2C%20soft%20natural%20lighting%2C%20clean%20editorial%20style%2C%20neutral%20tones&width=200&height=140&seq=more-cat-other-v2&orientation=landscape" },
];

export default function MoreCategories() {
  return (
    <section className="bg-background-50 py-16 md:py-20 px-4 md:px-6">
      <div className="max-w-6xl mx-auto">
        <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950 text-center mb-10">
          Więcej kategorii
        </h2>

        <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-3 md:gap-4">
          {remainingCategories.map((cat) => (
            <a
              key={cat.name}
              href={cat.url}
              target="_blank"
              rel="noopener nofollow"
              className="group flex items-center gap-3 p-3 bg-background-100 rounded-xl hover:bg-background-200 transition-colors cursor-pointer"
            >
              <div className="w-14 h-10 rounded-lg overflow-hidden flex-shrink-0">
                <img
                  src={cat.image}
                  alt={cat.name}
                  className="w-full h-full object-cover"
                  loading="lazy"
                />
              </div>
              <span className="text-sm font-medium text-foreground-700 group-hover:text-foreground-950 transition-colors whitespace-nowrap">
                {cat.name}
              </span>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}